import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set wedding date to August 22, 2026
    const weddingDate = new Date('2026-08-22T14:00:00');
    const timer = setInterval(() => {
      const now = new Date();
      const difference = weddingDate.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const timeUnits = [{
    label: 'Days',
    value: timeLeft.days
  }, {
    label: 'Hours',
    value: timeLeft.hours
  }, {
    label: 'Minutes',
    value: timeLeft.minutes
  }, {
    label: 'Seconds',
    value: timeLeft.seconds
  }];
  return <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-72">
      {timeUnits.map((unit, index) => <motion.div key={unit.label} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.15,
      duration: 1,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} className="relative group" data-id="element-73">
          {/* Terracotta Tile */}
          <div className="w-24 h-28 md:w-32 md:h-40 bg-[#D4735E] rounded-lg shadow-lg flex flex-col items-center justify-center relative overflow-hidden transform transition-transform duration-500 hover:-translate-y-1" style={{
        boxShadow: '0 10px 25px -5px rgba(212, 115, 94, 0.4)',
        borderRadius: '12px 4px 12px 4px' // Organic/imperfect shape
      }} data-id="element-74">
            {/* Texture overlay */}
            <div className="absolute inset-0 opacity-20 mix-blend-overlay bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')]" data-id="element-75"></div>

            {/* Sun glare effect */}
            <div className="absolute -top-10 -right-10 w-20 h-20 bg-white opacity-10 blur-xl rounded-full" data-id="element-76"></div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-77">
              <span className="text-4xl md:text-5xl font-serif text-[#FDFBF7] font-medium drop-shadow-sm" data-id="element-78">
                {String(unit.value).padStart(2, '0')}
              </span>
              <span className="text-xs md:text-sm uppercase tracking-widest text-[#FDFBF7]/80 mt-2 font-sans font-medium" data-id="element-79">
                {unit.label}
              </span>
            </div>

            {/* Bottom edge highlight */}
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-black/10" data-id="element-80"></div>
          </div>
        </motion.div>)}
    </div>;
}